import { render, staticRenderFns } from "./PlaylistCopy.vue?vue&type=template&id=4dba9184"
import script from "./PlaylistCopy.vue?vue&type=script&lang=js"
export * from "./PlaylistCopy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports